<template>
    <Modal v-model="visible" :loading="modalLoading" closable mask-closable @on-ok="ok" :okText="getTranslation('k048')"
        cancelText="" :title="title" width="80">

        <div class="tab-navigation-container">
            <div class="nav-button nav-prev" @click="tabChange(-1)" :class="{ disabled: !canPre }">
                <Icon type="ios-arrow-back" />
            </div>
            <Tabs type="card" class="custom-tabs" v-model="selectMode">
                <TabPane :label="getTranslation('r101')" name="m1" class="custom-tabpane">
                    <Row type="flex" class="normal-row">
                        <Col flex="1">{{ getTranslation('b006') }}:</Col>
                        <Col flex="2"><Input type="text" class="input-field" disabled
                            v-model="selectLibrary.NoWeldProgram" /></Col>
                        <Col flex="1">{{ getTranslation('b007') }}:</Col>
                        <Col flex="2"><Input type="text" class="input-field" disabled
                            v-model="selectLibrary.WeldProgram" />
                        </Col>
                        <Col flex="3">
                        </Col>
                    </Row>
                    <Row type="flex" class="normal-row">
                        <Col flex="1">{{ getTranslation('k269') }}:</Col>
                        <Col flex="2"><Input type="text" class="input-field" disabled
                            v-model="selectLibrary.PartName" />
                        </Col>
                        <Col flex="1">{{ getTranslation('k172') }}:</Col>
                        <Col flex="2"><Input type="text" class="input-field" disabled
                            v-model="selectLibrary.BatchNumber" />
                        </Col>
                        <Col flex="1">{{ getTranslation('u008') }}:</Col>
                        <Col flex="2"><Input type="text" class="input-field" disabled v-model="selectLibrary.Worker" />
                        </Col>
                    </Row>
                    <Card class="card-container" dis-hover>
                        <div slot="title" class="card-title">{{ getTranslation('r102') }}</div>
                        <div class="table">
                            <Row type="flex">
                                <Col flex="1" class="flex-middle">{{ getTranslation('k230') }}</Col>
                                <Col flex="1" class="flex-middle">{{ getTranslation('r014') }}</Col>
                                <Col flex="1" class="flex-middle">{{ getTranslation('r015') }}</Col>
                                <Col flex="1" class="flex-middle">{{ getTranslation('r016') }}</Col>
                                <Col flex="1" class="flex-middle">{{ getTranslation('r017') }}</Col>
                                <Col flex="1" class="flex-middle">{{ getTranslation('r018') }}</Col>
                                <Col flex="1" class="flex-middle">{{ getTranslation('r019') }}</Col>
                                <Col flex="1" class="flex-middle">{{ getTranslation('r020') }}</Col>
                            </Row>
                            <Row type="flex">
                                <Col flex="1" class="flex-middle">{{ selectLibrary.ValCurrentGun }}</Col>
                                <Col flex="1" class="flex-middle">
                                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{selectLibrary.ValGun1SingleProdSpotCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{selectLibrary.ValGun2SingleProdSpotCnt }}</template>
                                <template v-else>-</template> </Col>
                                <Col flex="1" class="flex-middle">
                                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{selectLibrary.ValGun1ScheduleProdMfgCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{selectLibrary.ValGun2ScheduleProdMfgCnt }}</template>
                                <template v-else>-</template></Col>
                                <Col flex="1" class="flex-middle">
                                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{selectLibrary.ValGun1TotalProdMfgCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{selectLibrary.ValGun2TotalProdMfgCnt }}</template>
                                <template v-else>-</template></Col>
                                <Col flex="1" class="flex-middle">
                                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{selectLibrary.ValGun1TotalProdSpotCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{selectLibrary.ValGun2TotalProdSpotCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 3">{{selectLibrary.ValGun3TotalProdSpotCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 4">{{selectLibrary.ValGun4TotalProdSpotCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 5">{{selectLibrary.ValGun5TotalProdSpotCnt }}</template>
                                <template v-else>-</template></Col>
                                <Col flex="1" class="flex-middle">
                                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{selectLibrary.ValGun1StepIncNumCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{selectLibrary.ValGun2StepIncNumCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 3">{{selectLibrary.ValGun3StepIncNumCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 4">{{selectLibrary.ValGun4StepIncNumCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 5">{{selectLibrary.ValGun5StepIncNumCnt }}</template>
                                <template v-else>-</template></Col>
                                <Col flex="1" class="flex-middle">
                                <template v-if="selectLibrary && selectLibrary.ValCurrentGun == 1">{{selectLibrary.ValGun1DressedNumCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 2">{{selectLibrary.ValGun2DressedNumCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 3">{{selectLibrary.ValGun3DressedNumCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 4">{{selectLibrary.ValGun4DressedNumCnt }}</template>
                                <template v-else-if="selectLibrary && selectLibrary.ValCurrentGun == 5">{{selectLibrary.ValGun5DressedNumCnt }}</template>
                                <template v-else>-</template></Col>
                                <Col flex="1" class="flex-middle">{{ selectLibrary.ValPrimCapVolt }}</Col>
                            </Row>
                        </div>
                    </Card>
                    <div class="separator-section">
                        <div class="separator-line"></div>
                    </div>
                    <div class="other-line">
                        <Row type="flex" class="row-line table-row-odd">
                            <Col flex="1">
                            </Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b018') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b019') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b020') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b021') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b022') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b023') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b024') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b025') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b026') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b027') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b028') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b029') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b030') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b031') }}</Col>
                            <Col flex="2" class="flex-middle">{{ getTranslation('b032') }}</Col>
                            <Col flex="1">
                            </Col>
                        </Row>
                        <Row type="flex" class="row-line">
                            <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-crr.png')" /></Col>
                            <Col flex="4">
                            </Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input flex-middle"
                                v-model="selectLibrary.CrrPreWeld" /></Col>
                            <Col flex="4">
                            </Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.CrrWeld1" /></Col>
                            <Col flex="2">
                            </Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.CrrWeld2" /></Col>
                            <Col flex="2">
                            </Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.CrrWeld3" /></Col>
                            <Col flex="4">
                            </Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.CrrPostWeld" /></Col>
                            <Col flex="4">
                            </Col>
                            <Col flex="1" class="flex-middle">KA</Col>
                        </Row>
                        <Row type="flex" class="row-line table-row-odd">
                            <Col flex="1"><img class="other-img" :src="require('@/assets/img/weld-time.png')" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimPrePress" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimMorePress" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimPreWeld" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimCold0" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimAscentWeld" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimWeld1" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimCold1" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimWeld2" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimCold2" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimWeld3" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimDescendWeld" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimCold3" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimPostWeld" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimKeep" /></Col>
                            <Col flex="2" class="flex-middle"><Input type="text" size="small" class="input"
                                v-model="selectLibrary.TimRelease" /></Col>
                            <Col flex="1" class="flex-middle"><template
                                v-if="machine.kind == 62">cyc</template><template v-else>ms</template></Col>
                        </Row>
                    </div>
                    <div class="separator-section">
                        <div class="separator-line"></div>
                    </div>
                    <div class="table">
                        <Row type="flex">
                            <Col flex="1" class="flex-middle">{{ getTranslation('k226') }}</Col>

                            <Col flex="1" class="flex-middle">{{ getTranslation('k231') }}</Col>
                            <Col flex="1" class="flex-middle">{{ getTranslation('k232') }}</Col>
                            <Col flex="1" class="flex-middle">{{ getTranslation('r021') }}</Col>
                            <Col flex="1" class="flex-middle">{{ getTranslation('r022') }}</Col>
                            <Col flex="1" class="flex-middle">{{ getTranslation('k233') }}</Col>
                            <Col flex="1" class="flex-middle">{{ getTranslation('k234') }}</Col>
                            <Col flex="1" class="flex-middle">{{ getTranslation('k235') }}</Col>
                        </Row>
                        <Row type="flex" class="row-line">
                            <Col flex="1" class="flex-middle">{{ selectLibrary.Vin }}</Col>
                            <Col flex="1" class="flex-middle">{{ selectLibrary.ValPowerCnt }}</Col>
                            <Col flex="1" class="flex-middle">{{ selectLibrary.ValDutyOnTime }}</Col>
                            <Col flex="1" class="flex-middle">{{ selectLibrary.ValPrgExpulsionCnt }}</Col>
                            <Col flex="1" class="flex-middle">{{ selectLibrary.ValSysExpulsionCnt }}</Col>
                            <Col flex="1" class="flex-middle">{{ selectLibrary.ValSecVolt }}</Col>
                            <Col flex="1" class="flex-middle">{{ selectLibrary.ValSecRest }}</Col>
                            <Col flex="1" class="flex-middle">{{ selectLibrary.DispRsv10 }}</Col>
                        </Row>
                    </div>

                </TabPane>
                <TabPane :label="getTranslation('r011')" name="m2" class="custom-tabpane">
                    <div style="width:100%">
                        <div ref="recordEcharts" :style="{ width: chartWidth, height: '550px' }"></div>
                    </div>
                </TabPane>
            </Tabs>

            <div class="nav-button nav-next" @click="tabChange(1)" :class="{ disabled: !canNext }">
                <Icon type="ios-arrow-forward" />
            </div>
        </div>

    </Modal>
</template>
<script>
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { Modal, Row, Col, Input, TabPane, Tabs, Card, Icon } from 'view-design';
import { mapGetters } from 'vuex'
import { postJsError, formatShorTime } from '@/util/util.js'
export default {
    name: 'MachineEdit', // 组件名称
    components: {
        Modal, Row, Col, Input, TabPane, Tabs, Card, Icon
    },
    props: {
        propVisible: Boolean,
        recordId: String,
        allItem: Array,
    },
    data() {
        return {
            modalLoading: true,
            mac: '',
            record: {},
            selectLibrary: {},
            machine: {},
            myChart: null,
            chartWidth: '100%',
            yAxisDefine: [],
            selectMode: "m1",
            curvesData: null,
            firstTime: false,
            selectedRecorId: '',
            zoomStart: 0,
            zoomEnd: 100,
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        visible: {
            get() { return this.propVisible },
            set(val) { this.$emit('input', val) }
        },
        title() {
            let rs = this.getTranslation('b176');
            if (this.selectLibrary && this.selectLibrary) {
                rs += ' [' + this.formatShorTime(this.selectLibrary.created_string) + ']' +
                    ' | '+this.getTranslation('k259')+'[' + this.selectLibrary.SpotId + ']' +
                    ' | '+this.getTranslation('b006')+'[' + this.selectLibrary.NoWeldProgram + ']'+
                    ' | '+this.getTranslation('k230')+'[' + this.selectLibrary.ValCurrentGun + ']'

            }
            return rs
        },
        canPre() {
            let can = false;
            let index = -1;
            this.allItem.forEach((oneItem, key) => {
                if (oneItem == this.selectedRecorId) {
                    index = key
                }
            })
            if (index > 0) {
                can = true;
            }
            return can
        },
        canNext() {
            let can = false;
            let index = -1;
            this.allItem.forEach((oneItem, key) => {
                if (oneItem == this.selectedRecorId) {
                    index = key
                }
            })
            if (index < this.allItem.length - 1) {
                can = true;
            }
            return can
        },

    },
    watch: {
        visible(newVal) {
            if (newVal) {
                if (this.recordId != '') {
                    this.selectedRecorId = this.recordId;
                    this.getDetail(this.recordId)
                }
            }
        }
    },

    created() {
        this.mac = this.$route.query.mac

    },
    methods: {
        initCurves() {
            this.$nextTick(() => {
                const parentWidth = this.$refs.recordEcharts.offsetWidth;
                this.chartWidth = `${parentWidth}px`;
                this.myChart = this.$echarts.init(this.$refs.recordEcharts);
                this.yAxisDefine = [
                    {
                        name: this.getTranslation('r081'),
                        show: true,
                        offset: 0,
                        position: 'left',
                        nameLocation: 'middle',
                        axisLine: { onZero: true },
                        type: 'value'
                    },
                    {
                        name: this.getTranslation('r082'),
                        show: true,
                        offset: 0,
                        position: 'right',
                        nameLocation: 'middle',
                        axisLine: { onZero: true },
                        type: 'value'
                    },
                    {
                        name: this.getTranslation('r083'),
                        show: true,
                        offset: 10,
                        position: 'left',
                        nameLocation: 'middle',
                        axisLine: { onZero: true },
                        type: 'value'
                    },
                    {
                        name: this.getTranslation('r084'),
                        show: true,
                        offset: 10,
                        position: 'right',
                        nameLocation: 'middle',
                        axisLine: { onZero: true },
                        type: 'value'
                    }
                ];
                this.myChart.setOption({
                    title: { text: "weld-curve", show: false },
                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    grid: {
                        left: '35px',
                        right: '45px',
                        top: '40px'
                    },
                    yAxis: this.yAxisDefine,
                    dataZoom: [{
                        id: 'dataZoomX',
                        type: 'slider',
                        xAxisIndex: 0,
                        bottom: 30,
                        filterMode: 'empty',
                        showDataShadow: true,
                        start: this.zoomStart,
                        end: this.zoomEnd
                    },
                        {
                            type: 'slider',
                            xAxisIndex: 0,
                            bottom: 30,
                            filterMode: 'empty',
                            showDataShadow: true
                        },
                        {
                            type: 'slider',
                            yAxisIndex: [0, 1, 2, 3],
                            filterMode: 'empty',
                            right: 0,
                            showDataShadow: true
                        },
                    ],
                    xAxis: {
                        data: []
                    },
                    legend: {
                        data: []
                    },
                    series: [{
                        name: this.getTranslation('r081'),
                        type: 'line',
                        data: []
                    }],
                    graphic: [
                        {
                            id: 'selectionRect',
                            type: 'rect',
                            invisible: true,
                            silent: true,
                            shape: {
                                x: 0,
                                y: 0,
                                width: 0,
                                height: 0
                            },
                            style: {
                                fill: 'rgba(135, 206, 250, 0.3)',
                                stroke: '#1E90FF',
                                lineWidth: 1
                            },
                            z: 100
                        }
                    ]
                });
                this.setBrush();
            })
        },
        getDetail(id) {
            this.$emit('change-record', id);
            let url = API_URL["recordDetail"];
            let params = {
                id: id,
                mac: this.mac
            }
            axios.get(url, {
                params: params
            })
                .then(res => {
                    if (res && res.data && res.data.code == 200) {
                        this.selectLibrary = res.data.data.record;
                        this.machine = res.data.data.machine.CurrentMachine;
                        this.curvesData = res.data.data.curves;
                        this.createCurves(this.curvesData)
                    } else if (res && res.data && res.data.msg) {
                        this.$Message.error(res.data.msg);
                    } else {
                        this.$Message.error(this.getTranslation('c001'));
                    }
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
        },
        ok() {
            this.visible = false
            this.resetModal();
        },
        resetModal() {
            this.$nextTick(() => {
                this.modalLoading = true;
            });
        },
        createCurves(data) {
            if (!this.myChart) {
                this.initCurves();
            }
            this.$nextTick(() => {
                let aSeries = [];
                let aLegend = [];
                if (data.current) {
                    aLegend.push(this.getTranslation('r081'));
                    aSeries.push({
                        name: this.getTranslation('r081'),
                        type: 'line',
                        tiled: '总量',
                        showSymbol: false,
                        // smooth: true,
                        color: '#f00',
                        lineStyle: { width: 1 },
                        yAxisIndex: 0,
                        data: data.current
                    });
                    this.yAxisDefine[0].show = true;
                } else {
                    this.yAxisDefine[0].show = false;
                    aSeries.push({
                        type: 'line',
                        name: this.getTranslation('r081'),
                        data: []
                    });
                }
                if (data.voltage) {
                    aLegend.push(this.getTranslation('r082'));
                    aSeries.push({
                        name: this.getTranslation('r082'),
                        type: 'line',
                        tiled: '总量',
                        showSymbol: false,
                        // smooth: true,
                        color: '#00f',
                        lineStyle: { width: 1 },
                        yAxisIndex: 1,
                        data: data.voltage
                    });
                    this.yAxisDefine[1].show = true;
                } else {
                    this.yAxisDefine[1].show = false;
                    aSeries.push({
                        name: this.getTranslation('r082'),
                        type: 'line',
                        data: []
                    });
                }
                if (data.resistance) {
                    aLegend.push(this.getTranslation('r083'));
                    aSeries.push({
                        name: this.getTranslation('r083'),
                        type: 'line',
                        tiled: '总量',
                        showSymbol: false,
                        // smooth: true,
                        color: '#0f0',
                        lineStyle: { width: 1 },
                        yAxisIndex: 2,
                        data: data.resistance
                    });
                    this.yAxisDefine[2].show = true;
                } else {
                    this.yAxisDefine[2].show = false;
                    aSeries.push({
                        name: this.getTranslation('r083'),
                        type: 'line',
                        data: []
                    });
                }
                if (data.press) {
                    aLegend.push(this.getTranslation('r084'));
                    aSeries.push({
                        name: this.getTranslation('r084'),
                        type: 'line',
                        tiled: '总量',
                        showSymbol: false,
                        // smooth: true,
                        color: '#FFA500',
                        lineStyle: { width: 1 },
                        yAxisIndex: 3,
                        data: data.press
                    });
                    this.yAxisDefine[3].show = true;
                } else {
                    this.yAxisDefine[3].show = false;
                    aSeries.push({
                        name: this.getTranslation('r084'),
                        type: 'line',
                        data: []
                    });
                }
                this.myChart.setOption({
                    legend: {
                        data: aLegend,
                        bottom: 0
                    },
                    yAxis: this.yAxisDefine,
                    xAxis: {
                        axisLine: { onZero: true },
                        type: 'category',
                        boundaryGap: false,
                        splitLine: {
                            show: true
                        },
                        data: data.xAxis
                    },
                    series: aSeries
                });
            })
        },
        formatShorTime(str) {
            return formatShorTime(str)
        },
        tabChange(index) {
            let inindex = -1;
            this.allItem.forEach((oneItem, key) => {
                if (oneItem == this.selectedRecorId) {
                    inindex = key
                }
            })
            let realIndex = inindex + index;
            if (this.allItem[realIndex]) {
                this.selectedRecorId = this.allItem[realIndex]
                this.getDetail(this.selectedRecorId)
            }

        },
        setBrush() {
            // 确保移除之前的事件监听器
            this.myChart.getZr().off('mousedown');
            //this.myChart.getZr().off('mousemove');
            this.myChart.getZr().off('mouseup');
            this.myChart.getZr().off('dblclick');

            // 绑定事件
            const zr = this.myChart.getZr();

            zr.on('mousedown', (e) => {
                if (e.event.which !== 1) return; // 只处理左键
                const inGrid = this.myChart.containPixel({ gridIndex: 0 }, [e.offsetX, e.offsetY]);
                if (!inGrid) return;

                this.isSelecting = true;
                this.startPos = { x: e.offsetX, y: e.offsetY };

                // 获取 grid 区域
                const gridModel = this.myChart.getModel().getComponent('grid', 0);
                if (gridModel) {
                    const grid = gridModel.coordinateSystem;
                    const rect = grid.getRect();

                    this.myChart.setOption({
                        graphic: {
                            id: 'selectionRect',
                            invisible: false,
                            shape: {
                                x: this.startPos.x,
                                y: rect.y,
                                width: 0,
                                height: rect.height
                            }
                        }
                    });
                  
                }
            });

            zr.on('mousemove', (e) => {
                if (this.isSelecting && this.startPos) {
                    const width = e.offsetX - this.startPos.x;

                    this.myChart.setOption({
                        graphic: {
                            id: 'selectionRect',
                            shape: { width }
                        }
                    });
                }
            });

            zr.on('mouseup', (e) => {
                if (this.isSelecting && this.startPos) {
                    this.isSelecting = false;
                    const endPos = { x: e.offsetX, y: e.offsetY };

                    const width = Math.abs(endPos.x - this.startPos.x);
                    if (width > 10) {
                        this.applyZoom(this.startPos.x, endPos.x);
                    }

                    // 隐藏选择框
                    this.myChart.setOption({
                        graphic: {
                            id: 'selectionRect',
                            invisible: true
                        }
                    });

                    this.startPos = null;
                }
            });

            zr.on('dblclick', (e) => {
                 const inGrid = this.myChart.containPixel({ gridIndex: 0 }, [e.offsetX, e.offsetY]);
                if (!inGrid) return;
                this.myChart.dispatchAction({
                    type: 'dataZoom',
                    dataZoomId: 'dataZoomX',
                    start: 0,
                    end: 100
                });
                
            });
        },
        applyZoom(startPixel, endPixel) {
            const xAxis = this.myChart.getModel().getComponent('xAxis', 0);
            if (!xAxis) return;

            const axis = xAxis.axis;
            const pixelExtent = axis.getGlobalExtent();
            const minX = Math.min(startPixel, endPixel);
            const maxX = Math.max(startPixel, endPixel);

            // 确保在轴范围内
            const clampedMin = Math.max(minX, pixelExtent[0]);
            const clampedMax = Math.min(maxX, pixelExtent[1]);

            if (clampedMax <= clampedMin) return;

            // 计算百分比
            const startPercent = (clampedMin - pixelExtent[0]) / (pixelExtent[1] - pixelExtent[0]) * 100;
            const endPercent = (clampedMax - pixelExtent[0]) / (pixelExtent[1] - pixelExtent[0]) * 100;

            this.myChart.dispatchAction({
                type: 'dataZoom',
                dataZoomId: 'dataZoomX',
                start: startPercent,
                end: endPercent
            });
           

        },

    },

}



</script>
<style>
.row-line .input .ivu-input {
    text-align: center;
}
</style>
<style scoped>
@import url('../../../assets/style/list.css');
@import url('../../../assets/style/tab.css');



.normal-row {
    margin-bottom: 5px;
}

.normal-row .input-field {
    width: 95%;
}

.other-img {
    width: 14px;
}

.row-line {
    margin: 5px 0;
}

.row-line .input {
    width: 90%;
    text-align: center;
}

/* 表格边框样式 */
.table {
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    overflow: hidden;
}

.tab-navigation-container {
    position: relative;
}

.nav-button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
    color: white;
    font-size: 20px;
    z-index: 10;
}

.nav-button:hover:not(.disabled) {
    background-color: rgba(0, 0, 0, 0.5);
    transform: translateY(-50%) scale(1.1);
}

.nav-button.disabled {
    opacity: 0.3;
    cursor: not-allowed;
}

.nav-prev {
    left: -10px;
}

.nav-next {
    right: -10px;
}

.custom-tabs {
    width: 100%;
}

.table .ivu-row {
    border-bottom: 1px solid #e8e8e8;
}

.table .ivu-col {
    border-right: 1px solid #e8e8e8;
    padding: 8px 4px;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.table .ivu-row:first-child .ivu-col {
    background-color: #f5f5f5;
    font-weight: bold;
}

/* 针对 disabled Input 组件的样式 */
::v-deep(.ivu-input.ivu-input-disabled),
::v-deep(.ivu-input[disabled]) {
    color: #999 !important;
    background-color: #f8f9fa !important;
    border-color: #ced4da !important;
    opacity: 1 !important;
    -webkit-text-fill-color: #999 !important;
}
</style>